import { createClient } from "@supabase/supabase-js";

/*
 * Frontend Supabase client — used ONLY for Realtime subscriptions.
 * All writes go through /api/crud and /api/config (server-side, service key).
 * This uses the public anon key which is safe for client-side use.
 *
 * Set these env vars in your Vercel project settings:
 *   REACT_APP_SUPABASE_URL     — your Supabase project URL
 *   REACT_APP_SUPABASE_ANON_KEY — your Supabase anon/public key
 */

const url = typeof process !== "undefined" && process.env?.REACT_APP_SUPABASE_URL;
const key = typeof process !== "undefined" && process.env?.REACT_APP_SUPABASE_ANON_KEY;

const supabase = url && key ? createClient(url, key) : null;

export default supabase;
